import React from 'react';
import '../../styles/mainContents.css' 
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import moment from 'moment';

function ConsignmentHeader(props) {

  //const postState = useSelector(state => state.posts);
  const history = useHistory();

  const {authreducer} = props;

  const routeChange_batteryManageConsignments = () =>{ 
    let path = `/battery/ManageConsignments`; 
    history.push(path);
  }

  return (

    <div className="mainCN">

      <div className='MainPageCN'>      
        <div className="ConsignmentPageHeading">                  
          <h1 className="ConsignmentPageTitle">
            <div>Consignments</div>
          </h1>
          <div style={ {clear: 'both'}}></div>
          {/* <ul id='nav'>
            <li>
              <button
                onClick={ () => {
                  routeChange_batteryManageConsignments()
                }}
                > ManageConsignments
              </button> 
            </li>
          </ul> */}
        </div>        
      </div>
    </div>

  );
}


const mapStateToProps = (state) => {
  //console.log("ConsignmentHeader mapStateToProps state: " + JSON.stringify(state));
 return {
   authreducer: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  //console.log("ConsignmentHeader mapDispatchToProps called ");
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsignmentHeader);